export default __webpack_public_path__ + "static/media/pic_three.68266484.jpeg";